jQuery(document).ready(function ($) {
  $(".header__main-navigation > li").click(function (e) {
    var removeClass = false;

    if ($(this).hasClass("active")) {
      removeClass = true;
    }

    $(".header__main-navigation > li").removeClass("active");

    if (!removeClass) {
      $(this).addClass("active");
    }
  });

  $(".header__main-navigation > li > a").click(function (e) {
    e.preventDefault();
  });

  $(document).on("click", function (event) {
    const linkElement = $(".header__main-navigation > li");
    let targetElement = event.target; // clicked element
    do {
      var matches = false;

      linkElement.each(function () {
        if ($(this).get(0) == targetElement) {
          matches = true;
        }
      });

      if (matches) {
        // This is a click inside. Do nothing, just return.
        return;
      }
      // Go up the DOM
      targetElement = targetElement.parentNode;
    } while (targetElement);

    // This is a click outside
    $(".header__main-navigation > li").removeClass("active");
  });
});
